import 'whatwg-fetch';
import StorageService from 'services/StorageService/';
import PubSub from 'services/PubSub/';
import CartAction from 'actions/Cart';
import { api } from 'config'
import SalesChannel from 'services/SalesChannel';

let cacheObject = {
    result: {
        order: null
    },
    promise: {
        order: null
    }
};

const getOrders = (orderState, monthOrder, orderId, page = 1) => {
    const token = StorageService.getItem('sessionData');
    return fetch(api.ordersV2 + `/checkout/pub/orders/?page=${page}${orderState}${monthOrder}${orderId}`, {
        headers: {
            'x-api-key': api.apiKey,
            'token': token
        }
    }).then(results => results.json())
        .then(results => {
            if (results && results.status === 401) {
                CartAction.logout(()=> {window.location.href = "/"});
            }
            return results;
        })
        .catch(() => {
            PubSub.dispatch('error_503');
            return false
        });
}

const getLastOrders = () => {
    const token = StorageService.getItem('sessionData');

    return fetch(api.orders + `/orders/last`, {
        headers: {
            'x-api-key': api.apiKey,
            'token': token
        }
    }).then(results => results.json())
        .then(results => {
            if (results && results.status === 401) {
                CartAction.cleanOrderForm().then(()=> window.location.href = '/');

                window.location.href = "/";
            }
            return results;
        })
        .catch(() => {
            PubSub.dispatch('error_503');
            return false
        });
}

const getLastOrder = (tokenParam) => {

    if (cacheObject.result.order) {
        return Promise.resolve(cacheObject.result.order);
    }

    if (!cacheObject.promise.order) {

        const token = tokenParam || StorageService.getItem('sessionData');

        cacheObject.promise.order =  fetch(api.orders + `/orders/lastone`, {
            headers: {
                'x-api-key': api.apiKey,
                'token': token
            }
        }).then(results => results.json())
            .then(results => {
                if (results && results.status === 401) {
                    CartAction.cleanOrderForm().then(()=> window.location.reload());
                }

                cacheObject.result.order = results;
                cacheObject.promise.order = null;
                return results;
            })
            .catch(() => {
                PubSub.dispatch('error_503');

                clearCachedOrder();

                return false
            });
    }

    return cacheObject.promise.order;

}

const clearCachedOrder = () => {
    cacheObject.result.order = null;
    cacheObject.promise.order = null;
}

const getOrder = (orderId) => {
    const token = StorageService.getItem('sessionData');
    return fetch(api.ordersV3 + `/checkout/pub/orders/${orderId}`, {
        headers: {
            'x-api-key': api.apiKey,
            'token': token
        }
    }).then(results => results.json())
        .then(results => {
            if (results && results.status === 401) {
                CartAction.logout(()=> {window.location.href = '/'});
            }
            return results;
        })
        .catch(() => {
            PubSub.dispatch('error_503');
            return false
        });
}

const getOrderGroup = (orderId) => {
    const token = StorageService.getItem('sessionData');
    return fetch(api.ordersV2 + `/checkout/pub/orders/group/${orderId}`, {
        headers: {
            'x-api-key': api.apiKey,
            'token': token
        }
    }).then(results => results.json())
        .then(results => {
            if (results && results.status === 401) {
                CartAction.logout(()=> {window.location.href = '/'});
            }
            return results;
        })
        .catch(() => {
            PubSub.dispatch('error_503');
            return false
        });
}

const getTransaction = (transactionId) => {
    const token = StorageService.getItem('sessionData');
    return fetch(api.transactionV1 + `/api/pvt/transactions/${transactionId}`, {
        headers: {
            'x-api-key': api.apiKey,
            'token': token
        }
    }).then(results => results.json())
        .then(results => {
            if (results && results.status === 401) {
                CartAction.logout(()=> {window.location.href = '/'});
            }
            return results;
        })
        .catch(() => {
            PubSub.dispatch('error_503');
            return false
        });
}

const getProducts = (itemID) => {
    const salesChannel = SalesChannel.getSalesChannel();
    const consults = [];
    itemID = _getSeparateIds(itemID);

    itemID.map(ids => {
        consults.push(fetch(api.catalog + `/catalog_system/pub/products/search/?sc=${salesChannel}&_from=0&_to=49${('&fq=skuId%3A' + ids.join('&fq=skuId%3A'))}`, {
            headers: {
                'x-api-key': api.apiKey
            }
        }).then(results => results.json())
            .catch(() => {
                PubSub.dispatch('error_503');
                return false
            }));
    });

    return Promise.all(consults);
}

const _getSeparateIds = (ids) => {
    const limit = 30;
    const separatorIds = [];
    let indexSeparator = 0;
    let indexId = 0;

    ids.map((id) => {
        if (indexId >= limit) {
            indexSeparator++;
            indexId = 0;
        }
        if (!separatorIds[indexSeparator]) {
            separatorIds[indexSeparator] = [];
        }
        separatorIds[indexSeparator].push(id);
        indexId++;
    });
    return separatorIds;
}

const getOrderStatusV2 = (orderId) => {
    const token = StorageService.getItem('sessionData');
    return fetch(api.ordersV2 + `/orden/status/${orderId}`, {
        headers: {
            'x-api-key': api.apiKey,
            'token': token
        }
    }).then(results => results.json())
        .then(results => {
            if (results && results.status === 401) {
                CartAction.logout(()=> {window.location.href = "/"});
            }
            return results;
        })
        .catch(() => {
            PubSub.dispatch('error_503');
            return false
        });
}
const setReschedule = (orderId, deliveryWindow) => {
    const token = StorageService.getItem('sessionData');
    const bodyObj = {
        "startDateUtc": deliveryWindow.startDateUtc,
        "endDateUtc": deliveryWindow.endDateUtc
    };
    return fetch(api.orders + `/order/reschedule/${orderId}`, {
        method: 'POST',
        headers: {
            'x-api-key': api.apiKey,
            'token': token,
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(bodyObj)
    }).then(results => results.json())
        .then(results => {
            if (results && results.status === 401) {
                CartAction.logout(()=> {window.location.href = "/"});
            }
            return results;
        })
        .catch(() => {
            PubSub.dispatch('error_503');
            return false
        });
}

const getOrderCancel = (orderId, comment) => {
    const token = StorageService.getItem('sessionData');
    const userData = StorageService.getSecureItem('userData');

    return fetch(api.orders + `/order/cancel/${orderId}`, {
        method: 'POST',
        headers: {
            'x-api-key': api.apiKey,
            'token': token,
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            "phone": userData.homePhone,
            "comment": comment
        })
    }).then(results => results.json())
        .then(results => {
            if (results && results.status === 401) {
                CartAction.logout(()=> {window.location.href = "/"});
            }
            return results;
        })
        .catch(() => {
            PubSub.dispatch('error_503');
            return false
        });
}

const OrdersService = {
    getOrder,
    getOrders,
    getLastOrder,
    getLastOrders,
    clearCachedOrder,
    getOrderGroup,
    getTransaction,
    getProducts,
    getOrderStatusV2,
    setReschedule,
    getOrderCancel
}

export default OrdersService;
